import moment from 'moment-timezone';
import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import { useSelector } from 'react-redux';
import { useRouter, Switch, Route } from "util/router";
import analytics from 'util/analytics';
import { wakeupCheckout } from 'util/api/CheckoutAPI'
import { frequencyFromExpiresIn } from 'components/NewOfferingButton'
import { compareOfferings } from 'lib/offerings';
import Accordion from 'react-bootstrap/Accordion'
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser();

const OfferingCardStyle = {
    border: 'none',
    height: '100%'
}

const OfferingButtonStyle = {
    width: "100%",
    // color: "var(--primary-color)",
    // color: "var(--primary-color)",
    // backgroundColor: "transparent",
    // borderColor: "var(--primary-color)",
}

function OfferingListItem(props) {

    const reactElement = props.descriptionHTML ? htmlToReactParser.parse(props.descriptionHTML) : null;

    return (
        <div border='transparent' className='card text-left p-0' style={{ border: 'none', width: '100%' }}>
            <Accordion>
                <div className='p-1'>
                    <div className='d-flex flex-row justify-content-between align-items-center'>
                        <div>
                            <h5 className='card-title mb-1'>
                                {props?.name ?? "Gift Card"}
                            </h5>
                            <div className="card-text m-0 p-0">
                                {props?.price}{props?.frequencyText ? ` ${props?.frequencyText}` : null}
                            </div>
                            {props?.description?.length > 0 && (
                                <Accordion.Toggle as={Button} variant="link" eventKey="0" className='primaryColor m-0 p-0'>
                                    View Details
                                </Accordion.Toggle>

                            )}
                        </div>
                        <div className="ml-2">
                            <button className="btn btn-primary primaryColor" style={{ "whiteSpace": "nowrap" }} onClick={props.clickHandler}>Buy</button>
                        </div>
                    </div>
                    <div>
                        <Accordion.Collapse eventKey="0">
                            <div>
                                {reactElement ? reactElement : props.description}
                            </div>
                        </Accordion.Collapse>
                    </div>
                </div>

            </Accordion>
            <hr />
        </div>
    )
}

function OfferingCard(props) {

    const reactElement = props.descriptionHTML ? htmlToReactParser.parse(props.descriptionHTML) : null;

    return (
        <div className="shadow card text-center" style={OfferingCardStyle}>
            <div className="card-body">
                <h6 className="card-title">{props?.name ?? "Gift Card"}</h6>
                <h3 className="card-title p-3">
                    {props?.price}
                </h3>
                <p>
                    {props.shortDescription}
                </p>
                <hr style={{ width: "50%", backgroundColor: "var(--primary-color)", opacity: '50%' }} />
                <div className="card-text text-left">
                    {reactElement ? reactElement : props.description}
                </div>
            </div>
            <div className="card-footer bg-transparent">
                <Button className="primaryColor" onClick={props.clickHandler} style={OfferingButtonStyle}>Buy Now</Button>
            </div>
        </div>
    )
}

moment.locale('en', {
    calendar: {
        lastDay: '[Yesterday]',
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        lastWeek: '[last] dddd [at] LT',
        nextWeek: 'dddd [at] LT',
        sameElse: 'MMM Do [at] LT'
    }
});

const giftModel = {
    name: "Gift Card",
    price: "$",
    frequencyText: "",
    shortDescription: "Any Value",
    description: "Purchase a gift card for your friends!"
}

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

function buildShortDescription(offering) {

    switch (offering.type) {
        case "pack":
            return offering.count + " Pack"
        case "subscription":
            if (offering.count > 99) {
                return capitalize(frequencyFromExpiresIn(offering.expiresIn)) + " Unlimted"
            } else {
                return capitalize(frequencyFromExpiresIn(offering.expiresIn)) + " " + offering.count + " Pack"
            }
    }

}

function OfferingList(props) {
    const widgetName = useSelector(state => state.widget.instructor.widgetName);
    const currency = useSelector(state => state.widget.instructor.instructorProfile?.currency ?? "USD");
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const offerings = useSelector(state => state.widget.offerings
        .filter(val => val.type !== 'challenge')
        .sort(compareOfferings))
        .map(offering => ({
            ...offering,
            price: currencyFormatter.format(offering?.price ?? 0),
            firstPeriodPrice: currencyFormatter.format(offering?.firstPeriodPrice ?? 0),
            frequencyText: offering.type == 'subscription' ? frequencyFromExpiresIn(offering.expiresIn) : "",
            shortDescription: buildShortDescription(offering)
        }));

    const user = useSelector(state => state.widget.instructor);

    useEffect(() => {
        wakeupCheckout().then(res => console.log(res))
    }, [])

    useEffect(() => {
        if (user) {
            analytics.page({
                title: 'Offering List'
            })
        }
    }, [user]);

    const router = useRouter();

    function openGiftCard() {
        router.push(`/${widgetName}/gifting`);
    }

    function openOffering(val) {
        analytics.track("Clicked Buy Offering")
        if (true) { // user has in browser checkout turnedon ....
            console.log(router)
            router.push(`${router.match.url}/checkout/${val.platformID}`)
            return;
        }
    }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                    frameHeight: height
                }, '*');
            }
        }
    }

    useEffect(() => {
        sendPostMessage();
    });

    return (
        <>
            <Switch>
                <Route path={router.match.url + "/cards"}>

                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3">
                        {offerings.map(val => (
                            <div key={val.id} className="col mb-4">
                                <OfferingCard clickHandler={() => openOffering(val)}  {...val} />
                            </div>
                        ))}
                        <div className="col mb-4">
                            <OfferingCard clickHandler={() => openGiftCard()} {...giftModel} />
                        </div>
                    </div>

                </Route>
                <Route path={router.match.url}>
                    <div className="">
                        {offerings.map(val => (
                            <div key={val.id} className="mb-4">
                                <OfferingListItem clickHandler={() => openOffering(val)}  {...val} />
                            </div>
                        ))}
                        <div className="mb-4">
                            <OfferingListItem clickHandler={() => openGiftCard()} {...giftModel} />
                        </div>
                    </div>

                </Route>
            </Switch>
        </>
    );
}

export default OfferingList;
